jQuery(document).ready(function(){
    jQuery('#startCancellationFunnel').on('click', function(e) {
        if (!jQuery('input:radio[name="cancelReason"]').is(":checked")) 
        {
            jQuery('#alert-container').addClass('alert-danger text-center').text('Please select one of the options below.').show();
        } 
        else if( jQuery('input:radio[name="cancelReason"]:checked').is('[data-bypass]') && jQuery('#originalCancelForm input[name="offers_available"]').val() == 1 )
        {
            jQuery('.btn-cancel-promo').click();
        }
        else if( jQuery('input:radio[name="cancelReason"]:checked').is('[data-bypass]') && jQuery('#originalCancelForm input[name="offers_available"]').val() == 0 )
        {
            jQuery('#originalCancelForm').submit();
        }
        else 
        {
            jQuery('#alert-container').removeClass('alert-danger').text('').hide();

            let modalToOpen = jQuery('input:radio[name="cancelReason"]:checked').data('popup');
            console.log(modalToOpen)
            jQuery(`#${modalToOpen}`).addClass('show')
            // document.querySelector('#' + modalToOpen).classList += ' d-none'
        }
    });

    const cancelPromoModals = ['#cancelPromoDrinkModal', '#cancelPromoFreeCrateModal', '#cancelPromo50offModal'];    
    let randomNum = 1;

    // close current cancel modal and open promo modal
    jQuery('.btn-cancel-promo').on('click', function(e) {
        
        //randomNum = Math.floor(Math.random() * (3 - 1 + 1) + 1);

        const cancelReason = jQuery('input:radio[name="cancelReason"]:checked').val();

        jQuery('.cancel-modal.promo-modal input[name="cancelReason"]').val( cancelReason );
        
        if( document.getElementById('originalCancelForm') && jQuery('#originalCancelForm input[name="offers_available"]').val() == 1 )
        {
            jQuery('.cancel-modal.show').modal('hide');
            
            jQuery(cancelPromoModals[randomNum]).modal('show'); // set promo offer to free crate
        }
        else
        {
            jQuery('#originalCancelForm').submit();
        }
    });

    jQuery(".cancel-modal.promo-modal form.ajax_form").on('submit', function(e)
    {
        let offerAccepted = jQuery(e.currentTarget).find("input[name='action']").val() == 'accept_promo' ? 1 : 0;

        let postData = {
            'promo_offered': jQuery(e.currentTarget).find("input[name='offer']").val(),
            'accepted': offerAccepted,
            'subscription_id': jQuery(e.currentTarget).find("input[name='subscription_id']").val(),
            'action': 'store_promo_data'
        };
        
        submitAjaxForm( '/wp-admin/admin-ajax.php', postData );
    });
});